"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IntlProvider = exports.createIntlProvider = void 0;
// export all from react-intl
__exportStar(require("react-intl"), exports);
var kyruus_intl_provider_1 = require("./components/kyruus-intl-provider");
Object.defineProperty(exports, "createIntlProvider", { enumerable: true, get: function () { return kyruus_intl_provider_1.createIntlProvider; } });
Object.defineProperty(exports, "IntlProvider", { enumerable: true, get: function () { return kyruus_intl_provider_1.IntlProvider; } });
__exportStar(require("./constants"), exports);
//# sourceMappingURL=index.js.map